function kitMediaLoad(updateActiveThumbnailParam = false) {
    const gallery = document.querySelector(".kit-media");
    if (!gallery) return;

    const thumbnails = gallery.querySelectorAll(".kit-media__thumbnail");
    const slidesContainer = gallery.querySelector(".kit-media__slides");
    const slides = gallery.querySelectorAll(".kit-media__slide");

    let currentIndex = 0;
    let scrollTimeout;

    function updateActiveThumbnail(index) {
        thumbnails.forEach((t, i) => {
            const isActive = i === index;
            t.classList.toggle("is-active", isActive);

            if (isActive) {
                t.setAttribute("aria-current", "true");
            } else {
                t.removeAttribute("aria-current");
            }
        });
    }

    function updateDots(index) {
        const dots = gallery.querySelectorAll(".kit-media__dot");
        dots.forEach((dot, i) => {
            dot.classList.toggle("is-active", i === index);
        });
    }

    function goTo(index) {
        if (index < 0 || index >= slides.length) return;

        currentIndex = index;

        slidesContainer.scrollTo({
            left: slides[index].offsetLeft,
            behavior: "smooth"
        });

        updateActiveThumbnail(index);
        updateDots(index);
    }

    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            goTo(index);
        });
    });

    // Scroll sync
    slidesContainer.addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
            const scrollLeft = slidesContainer.scrollLeft;
            const slideWidth = slides[0].offsetWidth;
            const index = Math.round(scrollLeft / slideWidth);

            if (index !== currentIndex) {
                currentIndex = index;
                updateActiveThumbnail(index);
                updateDots(index);
            }
        }, 100);
    });

    //  Navegación por teclado
    slidesContainer.addEventListener("keydown", (event) => {
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            goTo(currentIndex - 1);
        }

        if (event.key === "ArrowRight") {
            event.preventDefault();
            goTo(currentIndex + 1);
        }
    });

    if (updateActiveThumbnailParam) {
        updateActiveThumbnail(currentIndex);
        updateDots(currentIndex);
    }

    window.media = {
        kitMediaLoad,
        updateActiveThumbnail,
        goTo
    };
}

document.addEventListener("DOMContentLoaded", () => {
    kitMediaLoad(true);
});